
<style lang='scss' scoped>

.myCloud {
  position: relative;
  overflow: hidden;
  min-height: 13rem;
  .selectType {
    .allLi {
      color: #666666;
      display: inline-block;
      margin-right: 0.5rem;
      min-width: 0.5rem;
      max-width: 2.5rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      font-size: 0.28rem;
    }
    .allLi.active {
      color: #0497ff;
    }
    & > div {
      width: 6.86rem;
      padding: 0px 0.32rem;
      white-space: nowrap;
      overflow: hidden;
      // line-height: 0.8rem;
    }
    ul {
      // height: 0.8rem;
      width: 5.7rem;
      position: relative;
      overflow: scroll;
      -webkit-overflow-scrolling:touch;
      /*ios浏览器上隐藏滚动条无效，可以使用padding属性把滚动条定出范围,具体大小根据实际情况设定*/ 
      overflow-y: hidden;
      padding-left: 0.24rem;
      padding-bottom: 10px;
      // .hiddenScroll{
      //   height:4px;
      //   width:100%;
      //   background-color: red;
      //   position: absolute;
      //   bottom: 4px;
      // }
      // &::-webkit-scrollbar {
      //   display: none;
      // }
      li {
        margin-top:0.36rem;
        color: #666666;
        display: inline-block;
        border-radius: 0.24rem;
        background: #F7F7F7;
        margin-right: 0.48rem;
        min-width: 0.5rem;
        max-width: 2.5rem;
        padding:0.08rem 0.16rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
      }
      li.active {
        color: #ffffff;
        
background: #0497FF;
      }
    }
  }
  .codeData {
    padding-bottom: 2rem;
    li {
      margin-bottom: 0.3rem;
      margin-left: 3.46%;
      width: 44.26%;
      height:4.18rem;
      border: 1px solid #e6e9ed;
      .img_box {
        // width: 87.95%;
        height: 2.48rem;
        line-height: 2.48rem;
        border-top-right-radius: 0.05rem;
        border-top-left-radius: 0.05rem;
        padding: 0.2rem;
        text-align: center;
        background-color: #e6e9ed;
        img {
          vertical-align: middle;
          border-radius: 0.1rem;
          max-width: 87.95%;
          max-height: 2.48rem;
        }
      }
      .codeInfo {
        padding: 0.24rem 0.16rem 0.24rem 0.16rem;
        p {
          font-size: 0.28rem;
          margin-bottom: 0.2rem;
        }
        div.m_clearLR {
          font-size: 0.24rem;
          line-height: 0.24rem;
          color: #9a9a9a;
        }
      }
    }
  }
  .noDataTextEmpty{
    position: absolute;
    width:100%;
    text-align: center;
    margin-top:.5rem;
    color:#666;
    font-size:0.28rem;
    z-index: 999;
    padding-bottom: 0.5rem;
    img{
      width:1.99rem;
    }
    div{
      margin-top:0.5rem;
    }
  }
  .selectSort {
    position: absolute;
    top: 0.74rem;
  }
  .noData {
    text-align: center;
    margin-top: 0.5rem;
    color: #666;
    font-size: 0.28rem;
    padding-bottom: 1.5rem;
  }
}
</style>
<template>
  <div class="myCloud">
    <!-- <div class='sort m_clearLR' @click="openSort">
      <div class="sort_boxL m_clearLR m_floatL">
        <img src="@/../public/images/small.png" alt="" class="">
        <div class="m_floatR">按名称排序</div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR">
        <img src="@/../public/images/list.png" alt="" class="">
        <div class="m_floatR">大图</div>
      </div>
    </div>-->
    <!-- <selectSort class="selectSort" v-show="showSort" @selectSort='selectSort'></selectSort> -->
    <div class="selectType" >
      <div class="m_clearLR">
        <ul class="m_floatL">
          <li
            v-for="(item,_index) in cateData"
            :key="_index"
            @click="selectCate(_index)"
            :class="cateIndex==_index?'active':''"
          >{{item.name}}</li>
          <div class="hiddenScroll"></div>
        </ul>
      </div>
    </div>
    <ul class="codeData m_clearLR">
      <li class="m_floatL" v-for="(item,index) in cloudData" :key="index" @click="selectTag(item)">
        <div class="img_box">
          <img :src="item.img" alt />
        </div>
        <div class="codeInfo">
          <p class="textLine">{{item.name}}</p>
          <div class="m_clearLR">
            <div class="size m_floatL">{{item.updateTime|formatDate('')}}</div>
            <div class="size m_floatR">{{item.fileWidth+'*'+item.fileHeight}}</div>
          </div>
        </div>
      </li>
    </ul>
    <div class="noDataTextEmpty zhen_27" v-show="noDataTextEmpty" >
      <img src="@/../public/images/noData.png" />
      <div>{{_lang[$route.query.type].zhen_5}}</div>
    </div>
    <div class="noData zhen_7" v-show="noData">{{_lang[$route.query.type].zhen_5}}</div>
  </div>
</template>
<script>
import { lang } from "@/utils/i18n";
import selectSort from "@/components/selectSort";
// import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import jsSha256 from "js-sha256";
import {GetQueryString} from '@/../public/js/main.js'
import CryptoJS from "crypto-js";
import { DlabelTemplate, TemplateCategory, getFileSize, productPrintIndustry,productPrintTemplate } from "@/api/api";
var bridge = {
  default: this,
  call: function(b, a, c) {
    var e = "";
    "function" == typeof a && ((c = a), (a = {}));
    a = { data: void 0 === a ? null : a };
    if ("function" == typeof c) {
      var g = "dscb" + window.dscb++;
      window[g] = c;
      a._dscbstub = g;
    }
    a = JSON.stringify(a);
    if (window._dsbridge) e = _dsbridge.call(b, a);
    else if (window._dswk || -1 != navigator.userAgent.indexOf("_dsbridge"))
      e = prompt("_dsbridge=" + b, a);
    return JSON.parse(e || "{}").data;
  },
  register: function(b, a, c) {
    c = c ? window._dsaf : window._dsf;
    window._dsInit ||
      ((window._dsInit = !0),
      setTimeout(function() {
        bridge.call("_dsb.dsinit");
      }, 0));
    "object" == typeof a ? (c._obs[b] = a) : (c[b] = a);
  },
  registerAsyn: function(b, a) {
    this.register(b, a, !0);
  },
  hasNativeMethod: function(b, a) {
    return this.call("_dsb.hasNativeMethod", { name: b, type: a || "all" });
  },
  disableJavascriptDialogBlock: function(b) {
    this.call("_dsb.disableJavascriptDialogBlock", { disable: !1 !== b });
  }
};
!(function() {
  if (!window._dsf) {
    var b = {
        _dsf: { _obs: {} },
        _dsaf: { _obs: {} },
        dscb: 0,
        dsBridge: bridge,
        close: function() {
          bridge.call("_dsb.closePage");
        },
        _handleMessageFromNative: function(a) {
          var e = JSON.parse(a.data),
            b = { id: a.callbackId, complete: !0 },
            c = this._dsf[a.method],
            d = this._dsaf[a.method],
            h = function(a, c) {
              b.data = a.apply(c, e);
              bridge.call("_dsb.returnValue", b);
            },
            k = function(a, c) {
              e.push(function(a, c) {
                b.data = a;
                b.complete = !1 !== c;
                bridge.call("_dsb.returnValue", b);
              });
              a.apply(c, e);
            };
          if (c) h(c, this._dsf);
          else if (d) k(d, this._dsaf);
          else if (((c = a.method.split(".")), !(2 > c.length))) {
            a = c.pop();
            var c = c.join("."),
              d = this._dsf._obs,
              d = d[c] || {},
              f = d[a];
            f && "function" == typeof f
              ? h(f, d)
              : ((d = this._dsaf._obs),
                (d = d[c] || {}),
                (f = d[a]) && "function" == typeof f && k(f, d));
          }
        }
      },
      a;
    for (a in b) window[a] = b[a];
    bridge.register("_hasJavascriptMethod", function(a, b) {
      b = a.split(".");
      if (2 > b.length) return !(!_dsf[b] && !_dsaf[b]);
      a = b.pop();
      b = b.join(".");
      return (b = _dsf._obs[b] || _dsaf._obs[b]) && !!b[a];
    });
  }
})();
import moment from 'moment';
export default {
  data() {
    return {
      cateIndex: 0,
      sizeIndex: 0,
      showSort: false,
      page_size: 10,
      noData: false,
      tagTime: false,
      mac:"daf3b950-27ee-4d",
      noDataTextEmpty:false,
      page: 1,
      cloudData: [],
      loadingData: false,
      cateData: [],
      cateDatas: [{name:'商场超市',id:1},{name:'商场超市',id:2}],
      sizeData: [
        // { name: lang[this.$route.query.type].zhen_26, min: "", max: "" },
        // { name: "30以下", min: 0, max: 30 }
      ],
      sizeIndex: 0,
      _lang: [],
      keywords:''
    };
  },
  components: {
    selectSort
  },
  created() {
    productPrintIndustry()
    // dsBridge.register('setTempData',  (r, l)=> {
    //   this.page = 1
    //   this.keywords = r
    //   this.getData()
    // })
    this._lang = lang;
     this.getCate();
    window.onscroll = () => {
      if (
        this.getScrollTop() + this.getWindowHeight() >=
        this.getScrollHeight() - 500
      ) {
        this.addData();
      }
    };
    
  },
  filters: {
    //转化时间年月日
    formatDate(time) {
      if (!time) { return }
      return moment(time).format('MM-DD')
    }
  },
  methods: {
    base64_encode(str) {
    var c1, c2, c3;
    var base64EncodeChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var i = 0,
      len = str.length,
      string = "";

    while (i < len) {
      c1 = str.charCodeAt(i++) & 0xff;
      if (i == len) {
        string += base64EncodeChars.charAt(c1 >> 2);
        string += base64EncodeChars.charAt((c1 & 0x3) << 4);
        string += "==";
        break;
      }
      c2 = str.charCodeAt(i++);
      if (i == len) {
        string += base64EncodeChars.charAt(c1 >> 2);
        string += base64EncodeChars.charAt(
          ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
        );
        string += base64EncodeChars.charAt((c2 & 0xf) << 2);
        string += "=";
        break;
      }
      c3 = str.charCodeAt(i++);
      string += base64EncodeChars.charAt(c1 >> 2);
      string += base64EncodeChars.charAt(
        ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
      );
      string += base64EncodeChars.charAt(
        ((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6)
      );
      string += base64EncodeChars.charAt(c3 & 0x3f);
    }
    return string;
  },
  getEncry(str){
    let k2 = this.getCode(this.mac); // 对需要加密的数据进行加密
    k2 = this.buf2hex(this.base64ToUint8Array(k2));
    var k3 = this.encrypt(JSON.stringify(str));
    // k3 = this.base64_encode(k3)
    k3 = this.base64ToUint8Array(k3);
    k3 = this.buf2hex(k3);
    var k4 = this.base64_encode("key=" + k2 + "&text=" + k3);
    var k5 = this.stringArrayBuffer(k4);
    var k6 = this.buf2hex(k5);

    let sha256 = jsSha256.sha256; //这里用的是require方法
    var k7 = sha256(k6);
    return k6+','+k7
  },
    getCode(str) {
    //此处操作与后端约定参数
    // 创建RSAKey对象
    let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXRtG/gee0XLO+AGkp3qdI3pkntdB/5ej3DiCD3ZfTv1F1zl37I5ncXIQ9zpK5WEiGTCoVrywclj9etBdecchO2ZMVRT5MBb0EL7FZTdJz93xoAW6ZKbAUS4GBo20aM/7l+3JdX7L/fu/MIvT0GkKoNyTmWCC9VJ8/nKnj4b1uVwIDAQAB`; // ES6 模板字符串 引用 rsa 公钥
    let encryptStr = new JSEncrypt();
    encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    let data = encryptStr.encrypt(str.toString()); // 进行加密
    return data;
  },
  buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return Array.prototype.map
      .call(new Uint8Array(buffer), x => ("00" + x.toString(16)).slice(-2))
      .join("");
  },
  stringArrayBuffer(str) {
    const buffer = new ArrayBuffer(str.length);
    const bytes = new Uint8Array(buffer);

    str.split("").forEach(function(str, i) {
      bytes[i] = str.charCodeAt(0);
    });

    return buffer;
  },
  encrypt(plaintText) {
    const CRYPTOJSKEY = "daf3b950-27ee-4d";
    var plaintText = plaintText;
    var options = {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    };
    var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
    var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
    var encryptedBase64Str = encryptedData.toString().replace(/\//g, "_");
    encryptedBase64Str = encryptedBase64Str.replace(/\+/g, "-");
    return encryptedBase64Str;
  },
   base64ToUint8Array(base64String) {
　　　　const padding = '='.repeat((4 - base64String.length % 4) % 4);
       const base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/');
       const rawData = window.atob(base64);
       const outputArray = new Uint8Array(rawData.length);
       for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
       }
       return outputArray;
},
  _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  },
    selectTag(item) {
      clearTimeout(_tagTime);

      if (this.tagTime) return;
      var _tagTime = setTimeout(() => {
        this.tagTime = false;
      }, 2000);
      this.tagTime = true;
      var width = 0,
        height = 0;
      console.log({
        id: item.id,
        name: item.name,
        width: item.fileWidth,
        file:item.file,
        height: item.fileHeight,
        bgm:item.templateBackground?item.templateBackground:''
      })
      
      dsBridge.call("Dlabel.getTemplate", {
        id: item.id,
        name: item.name,
        width: item.fileWidth,
        file:item.file,
        height: item.fileHeight,
        bgm:item.templateBackground?item.templateBackground:''
      })
      
    },
    
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    //获取文档完整的高度
    getScrollHeight() {
      var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    getData() {
      this.loadingData = true;
      this.noData = false
      this.noDataTextEmpty = false
      // this.$indicator.open({
      //   text: "Loading..."
      // });
      var tempIndex = 0,min = '' ,max = '';
      if (this.sizeIndex != 0) {
        tempIndex = this.sizeIndex - 1;
        min = this.sizeData[tempIndex].sizeMin
        max = this.sizeData[tempIndex].sizeMax
      }
      // this.sizeData[this.sizeIndex-1].size_min
      var type = this.$route.query.type
      if(type==1){
        type = 2
      }else{
        type = 1
      }
      console.log(this.cateData)
      var tempData = {
        
        "equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          "appChannel": GetQueryString('appChannel'),
          "equip": GetQueryString('equip'),
          src:2,
          
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      // if(this.keywords.length<=0){
      //   tempData.sizeMin = min
      //   tempData.sizeMax = max
      //   tempData.templateTypeId =  this.cateIndex == 0 ? "" : this.cateData[this.cateIndex - 1].id
      // }else{
      //   tempData.keyWords = this.keywords
      // }
      tempData = this.getEncry(tempData)
      productPrintTemplate({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1],
      pageNo: this.page,
        pageSize: this.page_size,
        typeId:this.cateData[this.cateIndex].id,})
        .then(res => {
          // this.$indicator.close()
          this.cloudData = res.data.data.list;
          this.page++;
          if (
            this.cloudData.length < this.page_size
          ) {
            this.loadingData = true;
          }else{
            this.loadingData = false;
          }
         
          if(this.cloudData.length == 0){
            this.noDataTextEmpty = true
          }
          // setTimeout(()=>{
          //   alert(document.body.clientWidth)
          //   alert(document.querySelectorAll('.codeData li')[0].offsetWidth)
          // },1)
        })
        .catch(res => {
          if(this.page>2)
            this.noData = true;
          this.loadingData = true;
          // this.$indicator.close();
        });
    },
    addData() {
      if (this.loadingData) {
        return;
      }
      var tempIndex = 0,min = '' ,max = '';
      if (this.sizeIndex != 0) {
        tempIndex = this.sizeIndex - 1;
        min = this.sizeData[tempIndex].sizeMin
        max = this.sizeData[tempIndex].sizeMax
      }
      this.loadingData = true;
      // this.$indicator.open({
      //   text: "Loading..."
      // });
      var type = this.$route.query.type
      if(type==1){
        type = 2
      }else{
        type = 1
      }
      var tempData = {
        typeId:this.cateData[this.cateIndex].id,
        pageNo: this.page,
        pageSize: this.page_size,
        // sizeMin: min,
        // sizeMax: max,
        "equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          "appChannel": GetQueryString('appChannel'),
          src:2,
          // languageId:type,
          "equip": GetQueryString('equip'),
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      console.log(tempData)
      tempData = this.getEncry(tempData)
      productPrintTemplate({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]})
        .then(res => {
          this.page++;
          //this.$indicator.close();
          if (
            res.data.data.list.length <= 0 ||
            res.data.data.list.length < this.page_size
          ) {
            this.noData = true;
            this.loadingData = true;
          } else {
            this.loadingData = false;
          }
          res.data.data.list.forEach(element => {
            this.cloudData.push(element);
          });
        })
        .catch(res => {
          this.noData = true;
          this.loadingData = true;
          //this.$indicator.close();
        });
    },
    getCate() {
      var type = this.$route.query.type
      if(type==1){
        type = 2
      }else{
        type = 1
      }
      
      var tempData = {"equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          "appChannel": GetQueryString('appChannel'),
          src:2,
          "equip": GetQueryString('equip'),
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      tempData = this.getEncry(tempData)
      productPrintIndustry({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]}).then(res => {
        this.cateData = res.data.data;
        
    this.getData();
        // this.cateData.splice(0, 0, { id: "", name: lang[this.$route.query.type].zhen_26 });
      });
    },
    openSort() {
      this.showSort = true;
    },
    selectCate(index) {
      this.loadingData = false;
      window.scrollTo(0, 0);
      this.cateIndex = index;
      this.page = 1;
      this.getData();
    },
    selectSize(index) {
      window.scrollTo(0, 0);
      this.loadingData = false;
      this.page = 1;
      this.sizeIndex = index;
      this.getData();
    }
  }
};
</script>



